import React from 'react';
import iconGoogle from 'assets/googleIcon.png';
import iconFacebook from 'assets/facebookIcon.png';

const icons = { google: iconGoogle, facebook: iconFacebook };

export default function LoginIcon({ provider }) {
    return <img src={icons[provider]} alt={provider} height={26} />;
}
